import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button as PrimeButton } from 'primereact/button';
import FilterChip from '../FilterChip/FilterChip';
import styles from './TableFilters.styles.scss';
import cn from 'classnames';
import { isEmpty, isEqual } from 'lodash';

const FilterChipsDisplay = ({
  filtersConfig,
  values,
  initialValues,
  submitCount,
  filterValues,
  formRef,
  onResetFormClick,
}) => {
  const { t } = useTranslation();

  if (
    !(
      !isEqual(values, initialValues) &&
      !isEqual(values, {}) &&
      submitCount > 0
    )
  ) {
    return null;
  }

  const filters = filtersConfig
    .filters(values, filterValues, styles, t)
    .map((filter) => {
      const fieldNames = filter.fields
        .filter(
          (field) =>
            !field.hideChip &&
            !isEqual(filterValues[field.name], initialValues[field.name]) &&
            !isEmpty(filterValues[field.name]),
        )
        .map((field) => field.name);
      return (
        <FilterChip
          filter={filter}
          key={filter.title}
          label={t(filter.title)}
          formRef={formRef}
          values={filterValues}
          name1={fieldNames[0]}
          name2={fieldNames[1]}
        />
      );
    });

  return (
    <div className="d-flex gap-3 flex-wrap">
      {filters}
      {filters.length && (
        <PrimeButton
          onClick={() => {
            onResetFormClick();
            formRef.current?.resetForm?.();
          }}
          type="button"
          className={cn(styles.clearAllButton, 'text-decoration-underline')}
          label={t('common.clear_all')}
          link
        />
      )}
    </div>
  );
};

export default React.memo(FilterChipsDisplay);
